// extracted by mini-css-extract-plugin
export default {"container":"ResourceSearch_container__QhMKT","search":"ResourceSearch_search__ry50a"};